import { render, staticRenderFns } from "./ArtigosContentDialog.vue?vue&type=template&id=4ef6f101&scoped=true&"
import script from "./ArtigosContentDialog.vue?vue&type=script&lang=js&"
export * from "./ArtigosContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosContentDialog.vue?vue&type=style&index=0&id=4ef6f101&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6f101",
  null
  
)

export default component.exports